const base64js = require('base64-js');
const { Buffer } = require('buffer');

const SECRET_KEY = 2001020608;

function decodeBoxId(encodedStr) {
    try {
        // Decode from base64
        const paddedStr = encodedStr.padEnd(encodedStr.length + (4 - encodedStr.length % 4) % 4, '=');
        const decodedBytes = base64js.toByteArray(paddedStr);
        
        // Unpack the bytes to get the original number and salt
        const buffer = Buffer.from(decodedBytes);
        const numWithKey = buffer.readUInt32BE(0);
        const salt = buffer.readUInt8(4);
        
        // Reverse the secret key addition
        const num = numWithKey - SECRET_KEY;
        
        // Check if within original range
        if (num < 1 || num > 500) {
            throw new Error("Decoded number out of valid range.");
        }
        
        return num;
    } catch (error) {
        console.error("Error: Invalid or undecodable input.", error);
        return null;
    }
}

module.exports = decodeBoxId;